import ApiClient from '@raydiant/api-client-js';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Pubnub from 'pubnub';

interface RenderOptions {
  container: HTMLElement;
  deviceId: string;
  channelId: string;
  sessionId: string;
  apiClient: ApiClient;
  pubnubClient: Pubnub;
  pauseWhileOffline: boolean;
  appRendererUrl?: string;
  appRendererOfflineSupport?: boolean;
  onDeviceDeleted: () => void;
  logger: Logger;
  dashUrl?: string;
  injectAds?: boolean;
  signUpPage?: string;
  signUpQrCode?: React.ReactNode;
}

export default function render({
  container,
  deviceId,
  channelId,
  sessionId,
  apiClient,
  pubnubClient,
  pauseWhileOffline,
  appRendererUrl,
  appRendererOfflineSupport,
  onDeviceDeleted,
  logger,
  dashUrl,
  injectAds,
  signUpPage,
  signUpQrCode,
}: RenderOptions): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    createRoot(container).render(
      React.createElement(App, {
        deviceId,
        apiClient,
        pubnubClient,
        channelId,
        sessionId,
        pauseWhileOffline,
        appRendererUrl,
        appRendererOfflineSupport,
        onDeviceDeleted,
        onReady: resolve,
        onError: reject,
        logger,
        rootElement: container,
        dashUrl,
        injectAds,
        signUpPage,
        signUpQrCode,
      }),
    );
  });
}
